module.exports = __webpack_public_path__ + "static/media/3.question.56b2998a.mp4";